//

import { normalize } from 'normalizr';
import { browserHistory } from 'react-router';

import { simplApi } from '../../api/simplApi';
import { staff } from './schemas';

// import { receiveCompany } from './company';
import { receiveFile } from './file';
import { receiveActivity } from './activity';
import { fetchTotalData } from './totaldata';
import handleApiError from '../../helpers/handleApiError';
import { addFeedback } from './feedback';
import { fetchLimits } from './limits';
import { loginStatus } from './login';
import moment from 'moment/moment';
import { getBirthdayFromMeta } from '../../helpers/getBirthdayFromMeta';

const _ = require('lodash');

// ------------------------------------
// Constants
// ------------------------------------
export const REQUEST_STAFF = 'REQUEST_STAFF';
export const RECEIVE_STAFF = 'RECEIVE_STAFF';
export const SET_STAFF = 'SET_STAFF';
export const SET_STAFF_FORM = 'SET_STAFF_FORM';
export const CLOSE_STAFF_FORM = 'CLOSE_STAFF_FORM';
export const REMOVE_STAFF = 'REMOVE_STAFF';

// ------------------------------------
// Actions
// ------------------------------------

export function requestStaff() {
  return {
    type: REQUEST_STAFF,
  };
}

export function receiveStaff(staffs) {
  return {
    type: RECEIVE_STAFF,
    payload: {
      staffs,
    },
  };
}

export function setStaff(staffId) {
  return {
    type: SET_STAFF,
    payload: staffId,
  };
}

export function setStaffForm(staffId = 0) {
  return {
    type: SET_STAFF_FORM,
    payload: staffId,
  };
}

export function closeStaffForm() {
  return {
    type: CLOSE_STAFF_FORM,
  };
}

export const fetchStaff = staffId => dispatch => {
  dispatch(requestStaff());

  const url =
    typeof staffId !== 'undefined' && staffId !== null
      ? `staff/${staffId}`
      : 'staff';

  simplApi(url)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        let preparedStaffs;

        // console.log(json);

        // might be a bit unstable, but plural of staff is staffs...
        // might be a better idea to reformat using laravel
        if (typeof json.id === 'undefined') {
          preparedStaffs = normalize(json, [staff]);
        } else {
          preparedStaffs = normalize(json, staff);
        }

        // // console.log(preparedStaffs);

        dispatch(receiveStaff(preparedStaffs.entities.staffs));
        dispatch(receiveActivity(preparedStaffs.entities.activities));
        // dispatch(receiveCompany(preparedStaffs.entities.companies))
        dispatch(receiveFile(preparedStaffs.entities.files));
      }
    });
};

export function removeStaff(staffId) {
  return {
    type: REMOVE_STAFF,
    payload: staffId,
  };
}

export const deleteStaff = staffId => dispatch => {
  const url = `staff/${staffId}`;
  const options = { method: 'delete' };

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        dispatch(removeStaff(staffId));
        dispatch(addFeedback('warning', 'Mitarbeiter gelöscht'));
      }
    });
};

export const saveStaff = newStaff => dispatch => {
  // console.log('attempting to save a staff!');

  dispatch(requestStaff());

  let url = 'staff/';
  const options = { method: 'post', body: newStaff };
  if (typeof newStaff.id !== 'undefined' && newStaff.id !== null) {
    url = `${url}${newStaff.id}`;
    options.method = 'put';
  }

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        const preparedStaffs = normalize(json, staff);

        dispatch(receiveStaff(preparedStaffs.entities.staffs));
        dispatch(receiveFile(preparedStaffs.entities.files));

        dispatch(fetchTotalData());

        dispatch(addFeedback('success', 'Mitarbeiter gespeichert'));

        browserHistory.push(`/staff/${json.id}`);
      }
    });
};

export const switchAdmin = staffId => dispatch => {
  // console.log('attempting to change the admin!');

  const url = 'user/admin';
  const options = { method: 'post', body: { staffId } };

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        dispatch(addFeedback('success', json.message));
        dispatch(fetchStaff());
        dispatch(fetchLimits());
        dispatch(loginStatus());
      }
    });
};

export const inviteStaff = staffId => dispatch => {
  // console.log('attempting to invite a staff!');

  dispatch(requestStaff());

  const url = 'user/invite';
  const options = { method: 'post', body: { staffId } };

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        dispatch(addFeedback('success', json.message));
        dispatch(fetchStaff());
        dispatch(fetchLimits());
      }
    });
};

export const removeInvitedStaff = staffId => dispatch => {
  // console.log('attempting to remove the invite of a staff!');

  const url = 'user/removeInvite';
  const options = { method: 'post', body: { staffId } };

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        dispatch(addFeedback('success', json.message));
        dispatch(fetchStaff());
        dispatch(fetchLimits());
      }
    });
};

export const actions = {
  requestStaff,
  receiveStaff,
  setStaffForm,
  closeStaffForm,
  fetchStaff,
  saveStaff,
  deleteStaff,
  removeStaff,
  inviteStaff,
  removeInvitedStaff,
};

const STAFF_ACTION_HANDLERS = {
  [REQUEST_STAFF]: state => ({
    ...state,
    fetching: true,
  }),
  [SET_STAFF]: (state, action) => ({ ...state, current: action.payload }),
  [SET_STAFF_FORM]: (state, action) => ({
    ...state,
    formOpen: true,
    formTarget: action.payload,
  }),
  [REMOVE_STAFF]: (state, action) => ({
    ...state,
    staffs: _.omit(state.staffs, action.payload),
  }),
  [CLOSE_STAFF_FORM]: state => ({
    ...state,
    formOpen: false,
    formTarget: null,
  }),
  [RECEIVE_STAFF]: (state, action) => {
    const stateStaffs = Object.assign({}, state.staffs);
    const birthdays = Object.assign({}, state.birthdays);

    _.forOwn(action.payload.staffs, (_staff, id) => {
      const newStaff = _staff;
      const newMeta = {};

      _.forOwn(_staff.meta, value => {
        newMeta[value.key] = value;

        if (value.key === 'date_of_birth') {
          const birthday = getBirthdayFromMeta(_staff.meta, false);
          if (birthday) {
            newMeta[value.key].value = birthday.format('DD.MM.YYYY');
            birthday.year(moment().year());
            newMeta[value.key].birthdayAsDate = birthday.toDate();
            newMeta[value.key].birthdayEndAsDate = birthday
              .add(1, 'days')
              .toDate();
          }
        }
      });

      newStaff.meta = newMeta;

      if (typeof stateStaffs[id] === 'object') {
        Object.assign(stateStaffs[id], stateStaffs[id], newStaff);
      } else {
        stateStaffs[id] = newStaff;
      }

      if (
        newMeta.date_of_birth &&
        newMeta.date_of_birth.value !== null &&
        newMeta.date_of_birth.value.length &&
        newStaff.deleted_at === null
      ) {
        let birthday = moment(newMeta.date_of_birth.value, 'DD.MM.YYYY');
        if (!birthday.isValid()) {
          birthday = moment(newMeta.date_of_birth.value, 'YYYY-MM-DD');
        }

        const day = birthday.format('DD.MM');

        if (Array.isArray(birthdays[day])) {
          if (!birthdays[day].includes(id)) {
            birthdays[day].push(id);
          }
        } else {
          birthdays[day] = [id];
        }

        if (Array.isArray(birthdays['all'])) {
          if (!birthdays['all'].includes(id)) {
            birthdays['all'].push(id);
          }
        } else {
          birthdays['all'] = [id];
        }
      }
    });

    return {
      ...state,
      staffs: stateStaffs,
      birthdays,
      fetching: false,
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  fetching: false,
  current: null,
  formOpen: false,
  formTarget: null,
  staffs: {},
  birthdays: {
    all: [],
  },
};
export default function staffReducer(state = initialState, action) {
  const handler = STAFF_ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/staff.js